import React, { useEffect, useReducer, useState } from "react";
import DashboardContainer from "../../components/dashboard-container";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";
import CustomPagination from "../../components/pagination";
import UserModal from "../../components/users-modal.js";
import UsersList from "../../components/user-list/index.js";
import { usersService } from "../../utils/services/usersService.js";
import { userFilterInitialState } from "../../utils/filter-config.js";
import buildQuery from "../../utils/query-builder.js";

function filterReducer(state, action) {
  switch (action.type) {
    case "SET_FILTER":
      return {
        ...state,
        columns: state?.columns.map((x) =>
          x?.key === action?.payload?.key ? { ...x, ...action.payload } : x
        ),
      };
    case "SET_OPTIONS":
      return {
        ...state,
        columns: state.columns.map((col) =>
          col.key === action.payload.key
            ? { ...col, options: action.payload.options }
            : col
        ),
      };
    case "UPDATE_LIMIT":
      return { ...state, limit: action.payload };
    default:
      return state;
  }
}

export default function Users() {
  const [userData, setUserData] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(15);
  const [dataCount, setDataCount] = useState(rowsPerPage);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [viewMode, setViewMode] = useState("list");
  const [filterData, dispatch] = useReducer(
    filterReducer,
    userFilterInitialState
  );

  const clientId = localStorage.getItem("client_id");

  const fetchUserData = async () => {
    setLoading(true);
    try {
      const skip = page * rowsPerPage;
      const response = await usersService.fetchView(
        rowsPerPage,
        skip,
        clientId,
        buildQuery(filterData, page)
      );
      setUserData(response.data);
      setDataCount(response?.total);
    } catch (error) {
      console.error("Fetch failed:", error);
      // Handle fetch failure
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [page, rowsPerPage, searchValue, filterData]);

  const handleFilterChange = (newFilter) => {
    dispatch({ type: "SET_FILTER", payload: newFilter });
    setPage(0);
  };

  return (
    <DashboardContainer
      searchBarPlaceholder={"Search by User Name"}
      onSearchData={(p) => {
        setSearchValue(p);
        setPage(0);
      }}
      onClickRefresh={() => fetchUserData()}
      onClickAddButton={() => {
        setOpenModal(true);
      }}
      hideUploadButton={true}
      header={"Users List"}
      filterButton={false}
      title={" + Add User"}
      setViewMode={setViewMode}
      hideFilterClient
    >
      <UserModal
        selectedUser={selectedUser}
        handleClose={() => {
          setOpenModal(false);
          setSelectedUser(null);
        }}
        open={openModal}
        onAddData={fetchUserData}
        client_id={clientId}
      />
      {loading && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            color: "white",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      )}

      <UsersList
        onDeleteData={() => fetchUserData()}
        onEditData={(e) => {
          setSelectedUser(e);
          setOpenModal(true);
        }}
        data={userData}
        viewMode={viewMode}
        deleteTitle={"Delete Zone"}
        selectedUser={selectedUser}
        setSelectedUser={setSelectedUser}
        currentPage={page}
        itemsPerPage={rowsPerPage}
        onChangeFilter={handleFilterChange}
        filterData={filterData}
        client_id={clientId}
      />

      <CustomPagination
        dataCount={dataCount}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        disableNext={dataCount <= rowsPerPage * (page + 1)}
      />
    </DashboardContainer>
  );
}
